//https://www.patrick-wied.at/static/heatmapjs/
import h337 from 'heatmap.js';
//api methods.
import api from './api';

//container element 
let _container;
//The map element
let _map;
//Boolean to iodicate if map is currently shown.
let _show = false;
//Boolean to indicate wether a map load is already in progress.
let _loading = false;

//Id for the wrapper element.
const elementId = 'dnx-heatmap';
//maximum for number of seconds idle that is shown on map.
const maxShownValue = 10;

//Adds event listener to document keyup.
//Ctrl + Shift + H/h will toggle the heat map.
//Ctrl + Shift + L/l will reload the data from api.
const initMap = () => {
    document.addEventListener('keyup', (event) => {
        if(event.keyCode === 72 && event.ctrlKey && event.shiftKey) {
            _show = !_show;

            if (_show) {
                // reload data if the map was previously shown
                if (_container) setTimeout(reloadMap, 0);
                showMap();
                
            } else {
                hideMap();
            }
        } else if (event.keyCode === 76 && event.ctrlKey && event.shiftKey) {
            reloadMap();
        }
    });
};

//Create a new instance of heat map and get map data.
const createMap = () => {

    //lazy private with our container.
    _container = _container || createHeatMapElement();

    //Create map
    _map = h337.create({
        container: _container
    });

    //Fill map with data
    getMapData(_map);

    // The default initialization in heat map.js will set the wrapper to relative.
    // For our purposes we want it to be absolute (fill the screen)
    _container.style.position = 'absolute';
};

//Set map display to initial.
const showMap = () => {
    setVisible(true);
};

//Set map display to none.
const hideMap = () => {
    setVisible(false);
};

//Refill the map with data from api.
const reloadMap = () => {
    getMapData(_map);
};

// Creates a wrapper for heat map and sets the style.
// Height will be the maximum height we can find for the page so we have roomm for all the data.
const createHeatMapElement = () => {
    const body = document.body,
    html = document.documentElement;

    //Get the absolute max height we can find for the page.
    const height = Math.max( body.scrollHeight, body.offsetHeight, 
        html.clientHeight, html.scrollHeight, html.offsetHeight );

    //Styling to make sure heat map covers the entire page and is on top of everything.
    const heatmap = document.createElement('div');
    heatmap.setAttribute('id', elementId);
    heatmap.style.height = `${height}px`;
    heatmap.style.width = `${body.scrollWidth}px`;

    //Attach heatmap to body and return the newly created element.
    document.getElementsByTagName('body')[0].appendChild(heatmap);
    return document.getElementById(elementId);
};

//Get map data from api
const getMapData = (map) => {

    //create map if it doesn't yet exist.
    if(!_container) {
        createMap();
    }

    if(!_loading) {
        _loading = true;

        api.getHeatmapData(window.location.href).then(
            (data) => {

                //User can't see a map without data.
                if(data === []) {
                    hideMap();
                }
    
                // Max-min is the amount of seconds the mouse pointer has been idle.
                map.setData({
                    max: maxShownValue,
                    min: 0,
                    data: data
                });

                _loading = false; // Indicate we are done loading.
            },
            () => {
                hideMap(); //User can't see a map without data.
                _loading = false; //done loading.
            }
        );
    }
    
};

//Toggle visibility of the map container.
const setVisible = (visible) => {
    
    if(!_container) {
        createMap();
    }

    if(visible) {
        _container.style.display = 'initial';
    } else {
        _container.style.display = 'none';
    }
};

export default {
    initMap,
    showMap,
    hideMap,
    reloadMap
};